import React, { useState, useCallback } from 'react';
import RutasContent from '../sesgos/RutasContent';
import CrucesSesgosPanel from '../sesgos/CrucesSesgosPanel';

function SesgosComponent() {
  const [rutaSeleccionada, setRutaSeleccionada] = useState(null);

  const handleRutaSeleccionada = useCallback((ruta) => {
    setRutaSeleccionada(ruta);
  }, []);

  return (
    <div className="row" style={{ minHeight: '70vh' }}>
      {/* Panel izquierdo: lista de rutas con sesgos */}
      <div className={rutaSeleccionada ? 'col-xl-5 col-lg-5' : 'col-12'} style={{ transition: 'all 0.2s' }}>
        <RutasContent
          rutaSeleccionada={rutaSeleccionada}
          onRutaSeleccionada={handleRutaSeleccionada}
        />
      </div>

      {/* Panel derecho: cruces problemáticos de la ruta seleccionada */}
      {rutaSeleccionada && (
        <div className="col-xl-7 col-lg-7">
          <CrucesSesgosPanel
            key={rutaSeleccionada.id_Tipo_ruta}
            ruta={rutaSeleccionada}
            onClose={() => setRutaSeleccionada(null)}
          />
        </div>
      )}
    </div>
  );
}

export default SesgosComponent;
